import { useQuery } from '@tanstack/react-query';
import ContentService from '@/services/ContentService';
import type { ContentCatalogItem } from '@/services/ContentService';
import { CONTENT_KEYS } from './keys';

export function useContentCatalog(
  filters?: Record<string, unknown>,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: CONTENT_KEYS.catalog(filters),
    queryFn: () => ContentService.getContentCatalog(filters),
    enabled: options.enabled !== false,
  });
}

export type { ContentCatalogItem };
